import { fetchApi, getFetchApiJSONResponse, catchFetchApiError } from 'shared/functions';

export const uploadRequest = async (upload: any) => {
  const formData = new FormData();
  formData.append('file', upload, upload.name);

  const params = {
    method: 'POST',
    body: formData,
  };

  const url = '/esg/api/company-financial-data-upload/';

  return fetchApi(url, params, ['Content-Type'])
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
};
